<template>
  <v-layout row>
    <v-flex xs6 class="pb-3">
      <div class="pb-3 caption font-weight-bold">{{ text.amount }}</div>
      <div class="pb-3 body-1" style="color:#0270BA">
        {{ amount }} {{ text.currency }}
      </div>
      <div class="pb-3 caption red--text">
        {{ text.outstanding }} {{ outstanding }} {{ text.currency }}
      </div>
    </v-flex>
    <v-flex xs6 class="pb-1 caption text-xs-right">
      <router-link v-if="edit" :to="to">
        {{ text.edit }}
      </router-link>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['to', 'edit'],

  computed: {
    amount() {
      return this.twoDecimal(this.$store.state.amount)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    outstanding() {
      return this.twoDecimal(
        this.$store.state.outstanding - this.$store.state.amount
      )
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    text() {
      let obj = {}
      if (this.$store.state.language == 'EN') {
        obj = {
          amount: 'Amount',
          currency: 'THB',
          outstanding: 'Outstanding',
          edit: 'Edit'
        }
      } else {
        obj = {
          amount: 'ยอดที่ระบุ',
          currency: 'บาท',
          outstanding: 'จะเหลือยอดค้างชำระ',
          edit: 'แก้ไขยอดชำระ'
        }
      }
      return obj
    }
  },

  methods: {
    twoDecimal(val) {
      return parseFloat(val).toFixed(2)
    }
  }
}
</script>
